import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';

export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.vueApp.component('Swiper', Swiper);
	nuxtApp.vueApp.component('SwiperSlide', SwiperSlide);
});